import { IconContent } from '@icons';

export const reports: IconContent = {
    md: '<path d="M4 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Zm2 0H5v16h14V4H6Zm8 2v1h-4V6h4Zm2 3.5v-1h-6v1h6ZM14.5 11v1H10v-1h4.5ZM13 14.5v-1h-3v1h3ZM12 16v1h-2v-1h2ZM9 7V6H7v1h2Zm0 1.5v1H7v-1h2ZM9 12v-1H7v1h2Zm0 1.5v1H7v-1h2ZM9 17v-1H7v1h2Z" />',
};
